export default "__VITE_ASSET__6a98064a__"